import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './hero.css';
import bgImage from '../../asstes/banner.png';
import bgVideo from '../../asstes/banner-bg-video.mp4';

export const Hero = () => {
  const goToProducts = (e) => {
    e.preventDefault();
    const el = document.getElementById('products');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="hero" id="home">

      {/* Overlay */}
      <div className="hero__overlay"></div>

      {/* Content */}
      <Container fluid className="hero__content p-0">
        <Row className="g-0 align-items-stretch hero__row">

          {/* Col 8 — text content with bg image */}
          <Col xs={12} md={8} className="p-0">
            <a
              href="#products"
              className="hero__left"
              style={{ backgroundImage: `url(${bgImage})` }}
              onClick={goToProducts}
              aria-label="Go to products"
            >
              {/* <div className="hero__left-overlay"></div>
              <div className="hero__left-inner text-center">
                <h1 className="hero__title">Light Up Your Celebrations</h1>
                <p className="hero__description">
                  Discover premium quality crackers for every occasion. From dazzling sparklers to spectacular sky shots,
                  we bring joy and excitement to your special moments with 100% safe and licensed products.
                </p>
                <div className="hero__cta">
                  <Button variant="primary" size="lg" className="hero__btn hero__btn--primary">
                    Shop Now
                  </Button>
                  <Button variant="outline-light" size="lg" className="hero__btn hero__btn--outline">
                    View Combos
                  </Button>
                </div>
              </div> */}
            </a>
          </Col>

          {/* Col 4 — crackers video */}
          <Col xs={12} md={4} className="p-0">
            <div className="hero__right">
              <video className="hero__side-video" autoPlay loop muted playsInline>
                <source src={bgVideo} type="video/mp4" />
              </video>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};
